<app-page-header header="{{language.fundrecommmenutab1}}" backgroundPath="assets/images/lead/lead-brief.jpg"></app-page-header>
<div class="container" style="padding-top: 30px;">
  <section class="section-select -menu visible-sm visible-xs show-on-min">
    <app-dropdown [title]="'ข่าวสาร'" [valueDropdown]="valueDropdown"></app-dropdown>
  </section>
  <ul class="nav nav-tabs tab-four show-on-max" id="myTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="one"
        aria-selected="true">สรุปภาวะตลาด</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="two" aria-selected="false">Newsletter</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="three" aria-selected="false">
        VDO Clip</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="four-tab" data-toggle="tab" href="#four" role="tab" aria-controls="four" aria-selected="false">
        กองทุนแนะนำ</a>
    </li>
  </ul>


  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab" style="padding-top: 30px">
      <section class="show-listing -highlight">
        <div class="row">
          <div class="col-ss-12 col-xs-4 col-sm-4">
            <section class="card -new">
              <header>
                <h2 class="heading-topic" data-mh="heading-topic" style="height: 80px;">Morning Brief</h2>
              </header>
              <div class="thumb view">
                <div class="desc-thumb">
                  <a href="/media/morning_brief_file/backup/271/20181128.pdf" class="desc">

                    <!-- Morning Brief -->
                    <span class="date">28</span>
                    <span class="month-year">พฤศจิกายน<br>2561</span>

                    <span class="arrow-right">
                      <i class="icon icon-arrow-next"></i>
                    </span>
                  </a>
                </div>
                <a href="/media/morning_brief_file/backup/271/20181128.pdf" class="parent">
                  <span class="img-photo" style="background-image:url(../../../../../assets/media/news_image/87/photo-6.png)"></span>
                </a>
              </div>
            </section>
          </div>
          <div class="col-ss-12 col-xs-4 col-sm-4">
              <section class="card -new">
                <header>
                  <h2 class="heading-topic" data-mh="heading-topic" style="height: 80px;">Morning Brief</h2>
                </header>
                <div class="thumb view">
                  <div class="desc-thumb">
                    <a href="/media/morning_brief_file/backup/271/20181128.pdf" class="desc">
  
                      <!-- Morning Brief -->
                      <span class="date">28</span>
                      <span class="month-year">พฤศจิกายน<br>2561</span>
  
                      <span class="arrow-right">
                        <i class="icon icon-arrow-next"></i>
                      </span>
                    </a>
                  </div>
                  <a href="/media/morning_brief_file/backup/271/20181128.pdf" class="parent">
                    <span class="img-photo" style="background-image:url(../../../../../assets/media/news_image/87/photo-6.png)"></span>
                  </a>
                </div>
              </section>
            </div>
        </div>
      </section>
    </div>
    <div class="tab-pane fade" id="two" role="tabpanel" aria-labelledby="two-tab">

    </div>
    <div class="tab-pane fade" id="three" role="tabpanel" aria-labelledby="three-tab">

    </div>
    <div class="tab-pane fade" id="four" role="tabpanel" aria-labelledby="four-tab">
      <section class="show-listing -highlight" style="margin-top: 30px">
        <div class="row">
          <div class="col-ss-12 col-xs-4 col-sm-4">
            <section class="card -new ">
              <div class="thumb view">
                <a href="/th/news/detail/set in the city 2018" class="parent">
                  <span class="img-photo" style="background-image:url(../../../../../assets/media/news_image/87/photo-6.png)"></span>
                </a>
              </div>
              <div class="info">
                <h3 class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;"><a href="/th/news/detail/set in the city 2018">SET
                    in the city กรุงเทพมหานคร 2018</a></h3>
                <time>
                  03 ตุลาคม 2561 </time>
              </div>
            </section>
          </div>
          <div class="col-ss-12 col-xs-4 col-sm-4">
            <section class="card -new ">
              <div class="thumb view">
                <a href="/th/news/detail/CSR " class="parent">
                  <span class="img-photo" style="background-image:url(../../../../../assets/media/news_image/87/photo-6.png)"></span>
                </a>
              </div>
              <div class="info">
                <h3 class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;"><a href="/th/news/detail/CSR ">โครงการรอยยิ้มนี้เพื่อน้องและผองเพื่อน</a></h3>
                <time>
                  24 กันยายน 2561 </time>
              </div>
            </section>
          </div>
          <div class="col-ss-12 col-xs-4 col-sm-4">
            <section class="card -new ">
              <div class="thumb view">
                <a href="/th/news/detail/ONE-ALLCHINA" class="parent">
                  <span class="img-photo" style="background-image:url(../../../../../assets/media/news_image/87/photo-6.png)"></span>
                </a>
              </div>
              <div class="info">
                <h3 class="h6 topic-title insert-dotdotdot" style="overflow-wrap: break-word;"><a href="/th/news/detail/ONE-ALLCHINA">ONE-ALLCHINA
                    เปิดซื้อขายวันนี้ - 6 ก.ย.นี้ </a></h3>
                <time>
                  30 สิงหาคม 2561 </time>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  </div>

  <footer class="text-center" style="padding-top: 40px">
    <app-paginator></app-paginator>
    <!-- <ul class="list-unstyled list-inline pagination-page">
        <li class="prev text-right">
        </li>
        <li class="page">
          <div class="group-center">
            <span class="text">หน้า</span>
            <input id="paginateNumber" name="pageNumber" type="number" value="1">
            <span class="text">จาก 1</span>
          </div>
        </li>
        <li class="next text-left">
        </li>
      </ul> -->
  </footer>

</div>